import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.12655 9.00002L12.0065 12.88L15.8865 9.00002C16.2765 8.61002 16.9065 8.61002 17.2965 9.00002C17.6865 9.39002 17.6865 10.02 17.2965 10.41L12.7065 15C12.3165 15.39 11.6865 15.39 11.2965 15L6.70655 10.41C6.5193 10.2232 6.41406 9.96954 6.41406 9.70502C6.41406 9.4405 6.5193 9.18685 6.70655 9.00002C7.09655 8.62002 7.73655 8.61002 8.12655 9.00002Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
